"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarItem = void 0;
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importStar(require("react"));
var Sidebar_module_css_1 = __importDefault(require("./Sidebar.module.css"));
var SidebarMenuContext_1 = require("./SidebarMenuContext");
var material_1 = require("@mui/material");
var styleActive = {
    color: "var(--info-color)",
    backgroundColor: "var(--hover-color)"
};
function SidebarItem(props) {
    var text = props.text, link = props.link, icon = props.icon, target = props.target;
    var _a = (0, react_1.useState)(false), selected = _a[0], setSelected = _a[1];
    var _b = (0, react_1.useState)({
        color: "black"
    }), style = _b[0], setStyle = _b[1];
    var sidebarOpen = (0, react_1.useContext)(SidebarMenuContext_1.SidebarContext);
    var route = (0, useRoute_1.default)();
    var navItemWithText = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("img", { src: icon, alt: "", style: { height: "16px", width: "16px", marginRight: "26px" } }),
        react_1.default.createElement("p", { style: { marginBottom: "0px" } }, text));
    var navItemWithoutText = react_1.default.createElement("img", { src: icon, alt: "", style: { height: "16px", width: "16px" } });
    var sidebarNavItemStyling = sidebarOpen === true ? Sidebar_module_css_1.default.sidebar_nav_item : Sidebar_module_css_1.default.sidebar_nav_item_closed;
    var renderObject = sidebarOpen === true ? navItemWithText : navItemWithoutText;
    (0, react_1.useEffect)(function () {
        if (route().current() === link) {
            setStyle(styleActive);
            setSelected(true);
        }
        else if (route().current() === "editor/presentation" && link === "presentations") {
            setStyle(styleActive);
            setSelected(true);
        }
        else if (route().current() === "editor/playlist" && link === "playlists") {
            setStyle(styleActive);
            setSelected(true);
        }
    }, [route().current(), link]);
    var content = (react_1.default.createElement("span", null, target === "_blank" ? (react_1.default.createElement("a", { href: link, target: "_blank", rel: "noreferrer", className: "".concat(sidebarNavItemStyling, " ").concat(!selected ? "ns--font-family" : "ns-font-family-bold"), style: style }, renderObject)) : (react_1.default.createElement(inertia_react_1.InertiaLink, { href: route(link), style: style, className: "".concat(sidebarNavItemStyling, " ").concat(!selected ? "ns--font-family" : "ns-font-family-bold") }, renderObject))));
    //Add tooltip if the sidebar is closed
    if (!sidebarOpen) {
        return (react_1.default.createElement(material_1.Tooltip, { title: text, placement: "right" },
            react_1.default.createElement("span", null, content)));
    }
    else {
        return content;
    }
}
exports.SidebarItem = SidebarItem;
